import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://cob-messungen-2ed6b-default-rtdb.europe-west1.firebasedatabase.app/'
});

export default instance;